




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxCheckBox, DxDateBox, DxSwitch } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import { GenerateInvoiceFromProgressStatementsCommand, InvoiceListItemDto, InvoicesClient } from '@/data/web-api-client';

@Component({
  components: {
    DxCheckBox,
    DxDateBox,
    DxSwitch,
    Popup,
  },
})
export default class GenerateInvoiceFromProgressStatementsDialog extends Vue {
  @Prop({ required: true })
  projectId!: string;

  progressStatementIds?: string[];
  show: boolean = false;
  saving: boolean = false;
  loading: boolean = false;
  advancedInvoices: InvoiceListItemDto[] = [];
  projectEnded: boolean = false;
  endDate: Date = new Date();
  client = new InvoicesClient(undefined, this.$axios);

  public async open(list: string[]) {
    this.progressStatementIds = list;
    await this.loadData();
    this.show = true;
  }

  hideDialog() {
    this.show = false;
  }

  async save() {
    try {
      this.saving = true;

      const invoiceIds = this.advancedInvoices.filter((o: any) => o.selected).map((o: any) => o.id);
      const result = await this.client.generateFromProgressStatements(
        new GenerateInvoiceFromProgressStatementsCommand({
          projectId: this.projectId,
          sourceList: this.progressStatementIds,
          advancedInvoicesList: invoiceIds,
          projectEndDate: this.projectEnded ? this.endDate : undefined,
        })
      );

      notificationService.saved();
      this.$router.push({ path: `/invoices/${result}` });
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async loadData() {
    try {
      this.loading = true;
      this.advancedInvoices = await this.client.getUnprocessedAdvanced(this.projectId);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }
}
